function AjaxLoader(mainURL, parent){

    var self = this;
    this.parent = parent;


    self.mainURL = "http://" +document.domain;
    self.$loaderWrapper = $("#loader-wrapper");
    self.getPHPfile = self.mainURL + "/get.php";

    //self.imageLoader = new SequentialLoader({loadingGraphic : false}, function () {

     //   self.loaded();

    //});


}

AjaxLoader.prototype.load = function (contentURL){

    var self = this;

    ajaxInProgress = true;

    ajaxLoaderl = $.ajax({

        url: self.getPHPfile,
        data: {url : contentURL },

        success: function(d) {

            ajaxInProgress = false;

            var json = JSON.parse(d);

           // var content = JSON.parse(json.content);

            console.log("content ", json);

            /*self.$contentWrapper.html(json.content);

            document.title = json.title;

            var url = $('#content').css('background-image').replace(/^url\(['"]?/,'').replace(/['"]?\)$/,'');

            document.title = json.title;

            if (history.pushState) {

                history.pushState('data', '', contentURL);

            }

            self.imageLoader.addImage(url);

            self.imageLoader.loadImages();*/

        }
    });

};

AjaxLoader.prototype.loaded = function (){

    var self = this;

    self.parent.loadFinished();

};